import React, { useState } from 'react';
import * as RadixToast from '@radix-ui/react-toast';
import Toast from './Toast';

let toastId = 0;


const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    React.useEffect(() => {
        window.showToast = (message, type = 'info') => {
            const id = ++toastId;
            setToasts((prev) => [...prev, { id, message, type }]);
        };
        return () => { delete window.showToast; };
    }, []);

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    return (
        <RadixToast.Provider swipeDirection="right" duration={4000}>
            {toasts.map((toast) => (
                <Toast
                    key={toast.id}
                    id={toast.id}
                    message={toast.message}
                    type={toast.type}
                    onClose={removeToast}
                />
            ))}
            {/* Viewport renders the portal for toast items */}
            <RadixToast.Viewport className="toast-container" />
        </RadixToast.Provider>
    );
};

export default ToastContainer;
